module.exports = __webpack_public_path__ + "img/psinet.ae017188.png";